/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { DodTransferDocument } from "../models/dod-transfer-document";
import { DodTransferExportOptions } from "../models/dod-transfer-export-options";
import { DodTransferPlan } from "../models/dod-transfer-plan";
import { DodTransferImportRequest } from "../models/dod-transfer-import-request";
import { DodTransferApplyResult } from "../models/dod-transfer-apply-result";
import { DodTransferApplyRequest } from "../models/dod-transfer-apply-request";
@Injectable({
  providedIn: "root",
})
class AdminDodTransferService extends __BaseService {
  static readonly adminDodTransferExportPath = "/api/AdminDodTransfer/Export";
  static readonly adminDodTransferImportPreviewPath =
    "/api/AdminDodTransfer/ImportPreview";
  static readonly adminDodTransferImportApplyPath =
    "/api/AdminDodTransfer/ImportApply";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param options undefined
   */
  adminDodTransferExportResponse(
    options: DodTransferExportOptions
  ): __Observable<__StrictHttpResponse<DodTransferDocument>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = options;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodTransfer/Export`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodTransferDocument>;
      })
    );
  }
  /**
   * @param options undefined
   */
  adminDodTransferExport(
    options: DodTransferExportOptions
  ): __Observable<DodTransferDocument> {
    return this.adminDodTransferExportResponse(options).pipe(
      __map((_r) => _r.body as DodTransferDocument)
    );
  }

  /**
   * @param request undefined
   */
  adminDodTransferImportPreviewResponse(
    request: DodTransferImportRequest
  ): __Observable<__StrictHttpResponse<DodTransferPlan>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodTransfer/ImportPreview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodTransferPlan>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodTransferImportPreview(
    request: DodTransferImportRequest
  ): __Observable<DodTransferPlan> {
    return this.adminDodTransferImportPreviewResponse(request).pipe(
      __map((_r) => _r.body as DodTransferPlan)
    );
  }

  /**
   * @param request undefined
   */
  adminDodTransferImportApplyResponse(
    request: DodTransferApplyRequest
  ): __Observable<__StrictHttpResponse<DodTransferApplyResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdminDodTransfer/ImportApply`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DodTransferApplyResult>;
      })
    );
  }
  /**
   * @param request undefined
   */
  adminDodTransferImportApply(
    request: DodTransferApplyRequest
  ): __Observable<DodTransferApplyResult> {
    return this.adminDodTransferImportApplyResponse(request).pipe(
      __map((_r) => _r.body as DodTransferApplyResult)
    );
  }
}

module AdminDodTransferService {}

export { AdminDodTransferService };
